class ManifSearch {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("manifSearch", () => ({
                    urls: [],
                    url: null,
                    list: { url: "/" },
                    init() {
                        window.alpineRender(this);
                        this.url =
                            window.location.pathname + window.location.search;

                        const cache =
                            window.useLocalStorage?.get("navigations") ?? [];
                        window.useLocalStorage?.set("navigations", cache);
                        this.urls = cache;
                    },
                    next(url) {
                        if (!this.urls.includes(url)) {
                            this.urls.push(url);
                            window.useLocalStorage?.set(
                                "navigations",
                                this.urls,
                            );
                        }
                        window.location.href = url;
                    },
                    previous() {
                        if (this.urls && this.urls.length > 0) {
                            const index = this.urls.findIndex(
                                (u) => u === this.url,
                            );
                            if (index > 0) {
                                const redirectUrl = this.urls[index - 1];
                                this.urls.splice(index);
                                window.useLocalStorage?.set(
                                    "navigations",
                                    this.urls,
                                );
                                window.location.href = redirectUrl;
                            } else {
                                this.urls = [];
                                window.useLocalStorage?.set(
                                    "navigations",
                                    this.urls,
                                );
                                window.location.href = this.list.url;
                            }
                        }
                    },
                }));
            },
            { once: true },
        );
    }
}

new ManifSearch();
